import * as React from 'react';

import { NonEmptyArray, EBalconyType, JsonQuery } from '../../../../../JsonQuery';
import { Balcony } from '../../../components/advancedFilters/Balcony';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const BalconyContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const balconyTypes = new JsonQuery(jsonQuery).getBalconyTypes();

  const handleChange = React.useCallback(
    (balconyTypes: NonEmptyArray<EBalconyType>) => {
      onChange({ action: 'setBalconyTypes', arguments: [balconyTypes] });
    },
    [onChange],
  );

  return <Balcony value={balconyTypes} onChange={handleChange} />;
};
